import { combineEpics, ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators';
import { history } from 'index';
import toast from 'base/components/Toast/toast';
import { logout } from 'auth/store/auth/actions';
import * as actionTypes from './actionTypes';

const errorEpic = action$ =>
  action$.pipe(
    ofType(actionTypes.ERROR),
    switchMap(action => {
      if (action.error && action.error.status) {
        if (action.error.status === 401) {
          // login required
          return [logout()];
        }
        if (action.error.status === 403) {
          // access denied
          toast.warn('Access denied');
          // Log error to console, which will be reported to logrocket
          console.warn('Access denied', action.error); // eslint-disable-line
          history.push('/403');
          return [];
        }
        if (action.error.status === 404) {
          // not found
          // Log error to console, which will be reported to logrocket
          console.warn('Not found', action.error); // eslint-disable-line
          history.push('/404');
          return [];
        }
        // Other error with status message
        toast.error(`Unexpected error: ${action.error.message}`);
        console.error(`Unexpected error ${action.error.status}`, action.error.message); // eslint-disable-line
        return [];
      }
      if (action.error.message.startsWith('Request has been terminated')) {
        // server not reachable
        toast.error('Backend server not reachable. Please try again later.');
        return [];
      }

      // generic error
      toast.error('Unexpected error.');
      // Log error to console, which will be reported to logrocket
      console.error('Unexpected error', action.error); // eslint-disable-line
      return [];
    }),
  );

export default combineEpics(errorEpic);
